<template>
  <el-dialog
    title="查看结业状态"
    :visible.sync="dialogInfo.show"
    :close-on-click-modal="false"
    @close="handleClose"
    destroy-on-close
    width="600px"
  >
    <div class="item">
      <div class="item-left">结业状态：</div>
      <div class="item-right">
        {{ dialogInfo.row.graduationStatusName || "" }}
      </div>
    </div>
    <div class="item">
      <div class="item-left">备注：</div>
      <div class="item-right">{{ dialogInfo.row.graduationRemarks || "" }}</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" btntype="primary" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          member: {},
        };
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  line-height: 40px;
  .item-left {
    width: 100px;
    text-align: right;
  }
  .item-right {
    width: calc(100% - 100px);
  }
}
</style>
